export default "__VITE_ASSET__DlrEyW62__"